module.exports = __webpack_public_path__ + "static/kaddishcom-67be85d83cfe60eb246fef1cf18fe7ff.jpg";